import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_488: DocMigration = {
  maxSchemaVersion: "0.0.488",
  description: "Add enableAutoGeneratedFoundation and enableAutoGeneratedFloorSystem fields to all levels",
  apply(json: any) {
    // Check if levels exist in the document
    if (!json.levels) {
      return json;
    }

    // Iterate through all levels and add the new fields
    for (const levelId in json.levels) {
      const level = json.levels[levelId];

      // Add enableAutoGeneratedFoundation field with default value true
      if (typeof level.enableAutoGeneratedFoundation === "undefined") {
        level.enableAutoGeneratedFoundation = true;
      }

      // Add enableAutoGeneratedFloorSystem field with default value true
      if (typeof level.enableAutoGeneratedFloorSystem === "undefined") {
        level.enableAutoGeneratedFloorSystem = true;
      }
    }

    return json;
  },
};

export default migration_0_0_488;
